module.exports = __webpack_public_path__ + "static/media/full.dc760137.png";